import { isDevMode } from '@angular/core';
import { environment } from '@config/environments/environment';

// Each project have diffrent appId - you only need to change appId at this const.
/// Default appID;
export const APP_ID_FOR_PROJECT = environment.authen.appKey;

// Link support
const { forgotPassword, createNewAccount, verifyAtLogin, canNotLogin } =
  environment.authen.supportLink;
export const LINK_SUPPORT = {
  FORGOT_PASSWORD: forgotPassword,
  POLICY_WHEN_REGISTER: createNewAccount,
  VERIFY_ACCOUNT_AT_LOGIN: verifyAtLogin,
  CAN_NOT_LOGIN: canNotLogin,
};

export const LINK_NAVIGATE_TO_POLICY_WHEN_REGISTER = '';

// 5 lần login failure -> enable capcha
export const LOGIN_COUNT_ERROR_LIMIT_TO_ENABLE_CAPCHA = 5;

// Kích hoạt chức năng đăng nhập bằng facebook;
export const ENABLE_LOGIN_BY_FACEBOOK = isDevMode();
export const LOGIN_FACEBOOK_SECRET_KEY =
  environment.authen.facebookAuthSecretKey;
export const LOGIN_FACEBOOK_OPTIONS = {
  scope:
    'pages_messaging,pages_messaging_subscriptions,email,pages_show_list,manage_pages',
  return_scopes: true,
  enable_profile_selector: true,
};

// Kích hoạt chức năng thay đỗi mật khẩu
export const ENABLE_CHANGE_PASSWORD = true;

// Kích hoạt chức năng thay đỗi địa chỉ email
export const ENABLE_CHANGE_EMAIL = isDevMode();

// Kích hoạt chức năng xác minh lần đầu khi đăng nhập
export const ENABLE_VERIFY_AFTER_LOGIN_FIRST_TIME = !isDevMode();

// Kích hoạt chức năng yêu cầu bổ xung thông tin để xử dụng ứng dụng;
export const ENABLE_REQUIRE_UPDATE_INFO = !isDevMode();

export const ENABLE_CHOOSE_ACCOUNT_TYPE = true;
// DEFAULT ACCOUNT TYPE.
export const E_ACCOUNT_TYPE = {
  NHAN_VIEN: 'NHAN_VIEN',
  SINH_VIEN: 'SINH_VIEN',
};

export const ACCOUNT_TYPES = [
  {
    id: E_ACCOUNT_TYPE.NHAN_VIEN,
    key: 'nv',
    displayText: 'auth.component.login.form.staffAccounType',
    enableLanguage: true,
    show: true,
    default: true,
  },
  {
    id: E_ACCOUNT_TYPE.SINH_VIEN,
    key: 'sv',
    displayText: 'auth.component.login.form.studentAccountType',
    enableLanguage: true,
    show: true,
    default: false,
  },
];

export const API_VERSIONs = {
  VERSION_1_0_0: '1.0.0',
  VERSION_2_0_0: '2.0.0',
};

export enum AuthVersion {
  VERSION_1, // Phan quyen cu
  VERSION_2, // phan quyen moi
}

// Storage key.
// WARNING: SHOULD RENAME TO STORAGE_KEYS
export const SESSION_STORAGE_KEYS = {
  // Session storage:
  CALLBACK_URL: '___core_feature.authenticate.access_token_guard.callback_url',
  CURRENT_REQUIREMENT_AFTER_LOGIN:
    '___core_feature.authenticate.require_udpate_auth_info_after_login_first_time',
  LOGIN_ERROR_RECAPTCHA_COUNT:
    '___core_feature.authenticate.login_default.login_error_recaptcha_count',


  // First login
  HAVE_A_VERIFY_LOGIC: '___core_feature.authen.first_login_have_a_verify_logic',

  // Localstorage:
  OLD_ACCESS_TOKEN: '___core_feature.authenticate.old_access_token',
  ACCESS_TOKEN: '___core_feature.authenticate.access_token',
  LIST_ACTION_ACTIVE: '___core_feature.authenticate.list_action_active',
  USER_INFORMATION: '___core_feature.authenticate.user_information',
  REQUIRE_UPDATE_MORE_INFO_AFTER_ENTER_APP:
    '___core_feature.authenticate.require_update_more_info_after_enter_app',

  // Event emiter
  AUTH_EVENT: '___core_feature.authenticate.events',

  // Appkey
  APP_KEY: '___core_feature.authen.appKey',
};

// Upgrade login with token
export const URI_APIS_VERSION_1 = {
  LOGIN: '/login',
  LOGIN_BY_TOKEN: '/login-token',
};

// Apis VERSION 2
export const URI_APIs = {
  LOGIN: `/authen/user/enter-system/login-normal`,
  LOGIN_BY_TOKEN: `/authen/user/enter-system/login-token`,
  LOGIN_BY_THIRD_PARTY: `/authen/user/enter-system/login-th3`,
  GOOGLE_END_ACCESS_TOKEN_ENDPOINT: `/authen/user/enter-system/login-gmail`,
  LOGOUT: `/authen/user/enter-system/logout`,
  REGISTER: '/register',

  // Login 3th
  LOGIN_BY_GOOOGE: '/authen/user/enter-system/login-gmail',
  // Lien ket tai khoan google sau khi dang nhap username password thanh cong
  LINK_GOOGLE_ACCOUNT: '/authen/user/info/link-gmail',
  UN_LINK__GOOGLE_ACCOUNT: '/authen/user/info/unlink-gmail',

  LOGIN_BY_FACEBOOK: 'not-assign',

  // Forgot password
  FORGOT_PASSWORD: '/authen/user/require/forgot-pass/email',
  FORGOT_PASSWORD_HINT_EMAIL: '/authen/user/require/forgot-pass/email/get',
  FORGOT_PASSWORD_SET_NEW_PASSWORD_BY_OTP:
    '/authen/user/require/forgot-pass/set-new-password',
  FORGOT_PASSWORD_CONFIRM_OTP:
    '/authen/user/require/forgot-pass/flow-code/verify',

  // Verify account first login
  VERIFY_FIRST_LOGIN_GET_REQUIRE: '/authen/user/require/get-requirement',

  VERIFY_FIRST_LOGIN_EMAIL_ADDRESS:
    '/authen/user/require/first-login/update-email',

  VERIFY_FIRST_LOGIN_PHONE_NUMBER: '/authen/user/require/first-login/update-phone-number',
  VERIFY_FIRST_LOGIN_GET_HINT_PHONE_NUMBER:
    '/authen/user/enter-system/verify-email',

  VERIFY_FIRST_LOGIN_CHANGE_DEFAULT_PASSWORD:
    '/authen/user/require/first-login/change-password',

  // Api verify otp code dung chung cho tat ca cac nghiep vu dung .
  // TODO: Rename: VERIFY_OTP_CODE
  VERIFY_FIRST_LOGIN_CONFIRM_OTP: '/authen/user/flow-code/verify?code=',

  VERIFY_DEVICE: '/authen/user/require/verify-device',

  // Profile:
  PROFILE_UPDATE: `/authen/user/info/update`,
  PROFILE_GET: '/authen/user/info/get',
  PROFILE_UPDATE_EMAIL: `/authen/user/update-email`,
  PROFILE_CHANGE_PASSWORD: '/authen/user/change-pass',
  PROFILE_UPLOAD_AVATAR: 'profile/upload-avatar',
  PROFILE_UPDATE_PHONE_NUMBER: '/authen/user/update-phone-number',

  // Update info.
  REQUIRE_UPDATE_INFO_GET: '/authen/user/require/get-requirement',
  GET_CONTACT_LOGIN_METHOD: '/authen/user/list-3th-account-linked',

  // SSO
  SSO_REQUEST_AUTH_CODE: '/authen/sso/web/request-auth-code',

  // File
  UPLOAD_FILE: '/upload',
  DOWNLOAD_FILE: '/download?server_file_name=',
  GET_LIST: '/get-list',
};

export const PUBLIC_ASSET_PATH = 'assets';

// SSO Routes
export const SSO_ROUTES = {
  REQUEST_AUTHORIZATION: 'sso/request-authorization',
};
